import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { DebitoService } from 'app/services/debito.service';
import { Bancos, Sucursal, TipoCuenta, TipoDocumento } from 'app/entities/cobranza';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-debito-auto',
  templateUrl: './add-debito-auto.component.html',
  styleUrls: ['./add-debito-auto.component.scss']
})
export class AddDebitoAutoComponent implements OnInit {

  public bancos: Array<Bancos> = [];
  public sucursal: Array<Sucursal> = [];
  public tipo_cuenta: Array<TipoCuenta> = [];
  public tipo_documento: Array<TipoDocumento> = [];
  newForm: FormGroup;

  constructor
  (
    public _dialog: MatDialogRef<AddDebitoAutoComponent>, 
    private _debito: DebitoService,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private _data
  ) 
  { 
    this.newForm = this.createNewForm();
    console.log(_data);
  }

  ngOnInit() {
    this._debito.VerBancos().subscribe((data: Array<Bancos>) => this.bancos = data);
    this._debito.VerSucursal().subscribe((data: Array<Sucursal>) => this.sucursal = data);
    this._debito.VerTipoCuenta().subscribe((data: Array<TipoCuenta>) => this.tipo_cuenta = data);
    this._debito.VerTipoDocumento().subscribe((data: Array<TipoDocumento>) => this.tipo_documento = data);
    
    this._debito.VerDebitoxGrupo(this._data.base_datos, this._data.grupo,).subscribe((data: any) => {
      let debito: any = data[0];
      this.newForm.setValue({
        periodo: debito.periodo_debito ? debito.periodo_debito.toString() : debito.periodo_debito,
        banco: debito.banco,
        sucursal: debito.sucursal,
        tipo_cuenta: debito.tp_cuenta ? +debito.tp_cuenta : debito.tp_cuenta,
        cuenta: debito.cuenta,
        tipo_documento: debito.tp_documento ? +debito.tp_documento : debito.tp_documento,
        documento: debito.documento_titularC,
        nombre: debito.nombre_titularC
      })
    });
  }

  createNewForm(): FormGroup {
    return new FormGroup({
      periodo: new FormControl(null, [
        Validators.required
      ]),
      banco: new FormControl(null, [
        Validators.required
      ]),
      sucursal: new FormControl(null, [
        Validators.required
      ]),
      tipo_cuenta: new FormControl(null, [
        Validators.required
      ]),
      cuenta: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+'),
        Validators.required
      ]),
      tipo_documento: new FormControl(null, [
        Validators.required
      ]),
      documento: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+'),
        Validators.required
      ]),
      nombre: new FormControl(null, [
        Validators.required,
        Validators.pattern('[A-Za-z. ]+')
      ])
    });
  }

  guardarDebito(form: FormGroup): void {
    if(!form.get('periodo').value){
      this._snackBar.open('Seleccione un período', 'Aceptar', {
        duration: 2000,
        panelClass: 'yellow'
      });
      return;
    }else if(form.status === 'INVALID'){
      this._snackBar.open('Formulario Inválido', '', {
        duration: 2500,
        panelClass: 'warn-500'
      });
      return; 
    }

    this._debito.GuardarDebitoAuto(this._data.base_datos, this._data.grupo, form.value).subscribe((data: any) => {
      if(data['affectedRows'] > 0){
        this._snackBar.open('Débito Automático Agregado', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error al agregar Débito Automático', '', {
          duration: 2500,
          panelClass: 'warn-500'
        });
      }
    });
  }

}
